import React from "react";
import Footer from "../../components/common/Footer";

import PageHeading from "../../components/common/PageHeading";
import RightBar from "../../components/common/RightBar";

import RightBarMethod from "../../components/common/RightBar/RightBarMethod";

const WhatsNewRightBar = [
  RightBarMethod("", "t1", <i className=""></i>, [
    RightBarMethod("", "1", "", "", ""),
  ]),
];

function WhatsNewPage() {
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="WhatsNew" />
          {/* Footer  */}
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={WhatsNewRightBar} />
      </div>
    </>
  );
}

export default WhatsNewPage;
